/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModelCompanyTypeResource
 */
export interface ModelCompanyTypeResource {
    /**
     * 
     * @type {string}
     * @memberof ModelCompanyTypeResource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ModelCompanyTypeResource
     */
    countryCode: string;
}

/**
 * Check if a given object implements the ModelCompanyTypeResource interface.
 */
export function instanceOfModelCompanyTypeResource(value: object): value is ModelCompanyTypeResource {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function ModelCompanyTypeResourceFromJSON(json: any): ModelCompanyTypeResource {
    return ModelCompanyTypeResourceFromJSONTyped(json, false);
}

export function ModelCompanyTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelCompanyTypeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'countryCode': json['countryCode'],
    };
}

export function ModelCompanyTypeResourceToJSON(value?: ModelCompanyTypeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'countryCode': value['countryCode'],
    };
}

